import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { WifiOff } from "lucide-react";

export function VideoPlayer({ src }) {
  const videoRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return;
    setError(false);
    let hls;

    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
    } else if (Hls.isSupported()) {
      hls = new Hls({ liveDurationInfinity: true, lowLatencyMode: false });
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.ERROR, (_e, data) => {
        if (data.fatal) {
          if (data.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
          else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
          else setError(true);
        }
      });
    } else {
      setError(true);
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [src]);

  return (
    <div className="relative w-full aspect-video bg-black rounded-sm overflow-hidden border border-black/10">
      <video
        ref={videoRef}
        data-testid="hls-video-player"
        className="w-full h-full object-contain bg-black"
        controls
        autoPlay
        playsInline
        muted
      />
      {error && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-[#A1A1AA] bg-black/80">
          <WifiOff size={32} strokeWidth={1.5} />
          <p className="text-sm">Stream unavailable. Reconnecting…</p>
        </div>
      )}
    </div>
  );
}
